export default (languageCode: string) => /* GraphQL */ `
    query GetListsExtended($storeId: String, $includeStoreData: Boolean = false) {
        lists(itemPresentation: { languageCode: "${languageCode}", storeId: $storeId }) {
            isSelected
            listId
            name
            updated
            quantity
            designs {
                addedAt
                application
                configurationId
                quantity
                images {
                    typeCode
                    url
                }
                links {
                    deepLink
                    shortUrl
                }
                prices {
                    online {
                        regular {
                            subTotalInclDiscount {
                                exclTax
                                inclTax
                            }
                            unit {
                                exclTax
                                inclTax
                            }
                        }
                        family {
                            subTotalInclDiscount {
                                exclTax
                                inclTax
                            }
                            unit {
                                exclTax
                                inclTax
                            }
                        }
                    }
                }
            }
            items {
                addedAt
                itemNo
                quantity
                type
                isBreathTakingItem
                isBuyableOnline
                isCommunicatedOnline
                isFamilyItem
                isNew
                product {
                    type
                    description
                    measurements {
                        imperial
                        metric
                    }
                    images {
                        url
                        quality
                    }
                    globalName
                    displayUnit {
                        imperial {
                            unit
                            value
                        }
                        metric {
                            unit
                            value
                        }
                        type
                    }
                    technicalCompliances {
                        title
                        type
                        value
                    }
                }
                articles {
                    itemNo
                    quantityPerItem
                }
                prices {
                    online {
                        regular {
                            subTotalInclDiscount {
                                exclTax
                                inclTax
                            }
                            unit {
                                exclTax
                                inclTax
                                isLowerPrice
                                lowestPreviousPrice {
                                    exclTax
                                    inclTax
                                }
                                previousPrice {
                                    exclTax
                                    inclTax
                                }
                                validFrom
                                validTo
                            }
                        }
                        family {
                            subTotalInclDiscount {
                                exclTax
                                inclTax
                            }
                            unit {
                                exclTax
                                inclTax
                                lowestPreviousPrice {
                                    exclTax
                                    inclTax
                                }
                                previousPrice {
                                    exclTax
                                    inclTax
                                }
                                validFrom
                                validTo
                            }
                        }
                    }
                }
                availability {
                    homeDelivery {
                        minOrderQuantity
                         setsOf
                    }
                    clickCollect @include(if: $includeStoreData) {
                        minOrderQuantity
                        setsOf
                    }
                }
            }
        }
    }
`;
